import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ErrornDialog from "../../../Common/ErrorDialog/ErrorDialog";
import unbilledIcon from '../../../../assets/images/Unbilled.svg';
import { injectIntl } from 'react-intl';
import { getFormattedDate } from "../../../Common/DateUtils";


function Unbilled({ intl ,...props}) {
  const { user } = props;
  const { formatMessage } = intl;

  const unbilledData = useSelector(state => state.unbilled);



  return (
    <div
      className={props.order === 1 ? "tab-pane fade show active" : "tab-pane fade"}

      id="pills-unbilled"
      role="tabpanel"
      aria-labelledby="pills-unbilled-tab"
    >
      {unbilledData.unbilledPo?.loads.length > 0 ?
        <div className="custom-tiles-blocks row">
          {unbilledData.unbilledPo.loads.map((item, index) => {

            return (
              <div
                className="col-xs-12 col-xsm-6 col-sm-4 col-xl-4 col-xxl-3"
                key={index}
              >
                <div className="item position-relative">
                  <div className="contest_info">
                    <div className="contest_details">
                      <div className="d-flex justify-content-between align-items-center contest_date">
                        <span className="contest_title" title={item.load_control_num}>
                          {item.load_control_num}
                        </span>
                      </div>
                    </div>
                    <div className="description_block">
                      <div className="d-flex mb-3 align-items-center">
                        <i
                          className="fal fa-map-marker-alt fa-fw"
                          style={{ fontSize: "18px" }}
                        ></i>
                        <label className="mb-0 eventLocation" title={item.location}>
                          {item.location}{" "}
                        </label>
                      </div>
                      <div className="d-flex mb-3 align-items-center">
                        <img src={unbilledIcon} alt="React Logo" />

                        <label className="mb-0 eventLocation" title="Awaiting" style={{ marginLeft: "12px" }}>
                        {formatMessage({ id: "app.awaiting_header" })}</label>
                      </div>
                      <div className="d-flex mb-3 align-items-center">
                        <i
                          className="fal fa-calendar-alt fa-fw"
                          style={{ fontSize: "18px" }}
                        ></i>
                        <label
                          className="mb-0 eventLocation"
                          title={item.check_in_time}
                        >
                          {/* {item.check_in_time.substring(8, 10)}-{item.check_in_time.substring(5, 7)}-{item.check_in_time.substring(0, 4)} */}
                          {getFormattedDate(item.check_in_time)}
                        </label>
                      </div>
                    </div>
                    <div className="contest_btn_broup">
                      <Link to={`/unbilledDetails/${item.load_id}`} className="btn btn-chartreuse min-width">
                      {formatMessage({ id: "app.more_details" })}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            );

          })}
        </div>
        : <div class="empty_block m-auto">
          <img src={unbilledIcon} />
          <label class="text-center mb-3">{formatMessage({ id: "app.no_awaiting_load" })}<Link to={{
            pathname: `/help`
          }}><b className='text-orange ml-1'>{formatMessage({ id: "app.click_here" })}</b></Link> {formatMessage({ id: "app.load_help" })}</label>
        </div>}

    </div>
  );
}

export default injectIntl(Unbilled);
